import {
  AfterViewInit,
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  selector: '[appArxLoading]',
})
export class ArxLoadingDirective implements OnInit {
  @Input() appArxLoading = false;

  private spinnerRef!: ComponentRef<MatProgressSpinner>;

  constructor(
    private targetEl: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const bb = this.targetEl.nativeElement.getBoundingClientRect();

    const container = this.renderer.createElement('div');
    container.style.left = 'flex';
    container.style.justifyContent = 'center';
    container.style.alignItems = 'center';
    container.style.left = bb.length + 'px';
    container.style.width = bb.width + 'px';
    container.style.height = bb.height + 'px';

    this.spinnerRef =
      this.viewContainerRef.createComponent<MatProgressSpinner>(
        MatProgressSpinner
      );

    this.renderer.appendChild(
      this.targetEl.nativeElement,
      this.spinnerRef.instance._elementRef.nativeElement
    );
  }
}
